export const toggleProjectPriceAnalytics = ({ isToggledOn, pageType }) => window.LIFE_CYCLE_EVENT_BUS.trigger(
  'project-estimate-overlay.toggle-project-price',
  { isToggledOn, pageType }
);

export const overlayAnalytics = () => {
  window.LIFE_CYCLE_EVENT_BUS.trigger('project-estimate-overlay.overlay');
};